const state = {
  appointment: {
    steps: [
      { name: "one", active: true},
      { name: "two", active: false, patient: false, doctor: false},
      { name: "three", active: false},
      { name: "four", active: false}
    ],
    patient: { code: '' },
    doctor: {},
    data: {
      region: { label:'', value: '' },
      comunity: { label: '', value: '' },
      speciality: { label: '', value: '' },
      name: ''
    },
    country: ''
  }
}

const mutations = {
  'SET_TOKEN'(state, token) {
    state.appointment.patient.token = token
  },
  'SET_PATIENT'(state, patient) {
    state.appointment.patient = patient
  },
  'SET_STEP'(state, step) {
    state.appointment.steps.forEach( item => {
      if(item.name == step) item.active = true
      else item.active = false
    })
  },
  'SET_VISIBLE_PATIENT'(state){
    state.appointment.steps[1].patient = !state.appointment.steps[1].patient
  },
  'SET_VISIBLE_DOCTOR'(state, visible){
    state.appointment.steps[1].doctor = visible
  },
  'SET_COMMUNITY'(state, community) {
    state.appointment.community = community
  },
  'SET_DOCTOR'(state, doctor) {
    state.appointment.doctor = doctor
  },
  'SET_DATA'(state, data) {
    state.appointment.data.name = data.name
  },
  'SET_COUNTRY'(state, country){
    state.appointment.country = country
  },
  'CLEAR_DATA'(state) {
    state.appointment.data.name = ''
    state.appointment.data.region = { label:'', value: '', label2:'' }
    state.appointment.data.comunity = { label:'', value: '' , label2:'' }
    state.appointment.data.speciality = { label:'', value: '' , label2:'' }
  }
}

const actions = {
  setToken: ({commit}, token) => {
    commit('SET_TOKEN', token)
  },
  setPatient: ({commit}, patient) => {
    commit('SET_PATIENT', patient)
  },
  setStep: ({commit}, step) => {
    commit('SET_STEP', step)
  },
  setVisiblePatient: ({commit}) => {
    commit('SET_VISIBLE_PATIENT')
  },
  setVisibleDoctor: ({commit}, visible) => {
    commit('SET_VISIBLE_DOCTOR', visible)
  },
  setComunity: ({commit}, community) => {
    commit('SET_COMMUNITY', community)
  },
  setDoctor: ({commit}, doctor) => {
    commit('SET_DOCTOR', doctor)
  },
  setData: ({commit}, data) => {
    commit('SET_DATA', data)
  },
  setCountry: ({commit}, country) => {
    commit('SET_COUNTRY', country)
  },
  clearData: ({commit}) => {
    commit('CLEAR_DATA')
  }
}

const getters = {
  appointment: state => {
    return state.appointment
  }
}

export default {
  state,
  mutations,
  actions,
getters}



// WEBPACK FOOTER //
// ./src/store/modules/appointment.js